import { metricCardContainer as containerClasses } from '../metric-card-styles';

/**
 * Color for the out-of-order "!" indicator: orange when active, dropping to the
 * shared disabled gray when disabled. (The in-order state uses a green checkmark.)
 */
function getWarningColor(isDisabled: boolean): string {
  return isDisabled ? 'text-fg-disabled-subtle' : 'text-orange-500';
}

export { containerClasses, getWarningColor };
